import {useStores} from "../../../../Hooks";
import {observer} from "mobx-react";
import {FrontlineCheckbox} from "../../../Shared/FrontlineCheckbox";

export const ReportFields = observer(({fieldsType, title}) =>{
    const {workspaceManagementStore} = useStores();
    const isAllChecked = workspaceManagementStore.editedSubDomainReportsSettings[fieldsType].every(setting => setting.included);
    const onSelectAll = () => {
        workspaceManagementStore.editedSubDomainReportsSettings[fieldsType].forEach(setting => {
            setting.included = !isAllChecked;
        });
    }
    const renderSetting = (setting) => {
        return (
            <div className="flex flex-row gap-1 font-normal" key={setting.key}>
                <FrontlineCheckbox isChecked={setting.included} onChange={()=>setting.included = !setting.included } size={35} />
                <div className="mt-2">{setting.header}</div>
            </div>
        )
    }

    return (
        <div key={title} className="flex flex-col w-full border-t-1 border-t-nav-normal">
            <div className="flex flex-row gap-1 items-center">
                <FrontlineCheckbox isChecked={isAllChecked} onChange={onSelectAll} size={35} />
                <div className="text-main-normal text-lg font-semibold p-2">
                    Report fields ({title})
                </div>
            </div>
            <div
                style={{ columnCount: 2, columnGap: '1rem' }} className="w-full text-main-normal text-xs font-medium py-2"
            >
                {workspaceManagementStore.editedSubDomainReportsSettings[fieldsType].map((setting) =>
                    renderSetting(setting)
                )}
            </div>
        </div>
    )
});